import classNames from 'classnames';
import React from 'react';
import * as styles from './VerifiedIcon.module.scss';
import BorderedIcon from '../components/BorderedIcon';
import SVGIcon from '../components/SVGIcon';
import verifiedIcon from '../icons/non-prefilled/16x16/verifiedFilled.svg';

type SVGIconProps = React.ComponentProps<typeof SVGIcon>;

interface VerifiedIconProps extends SVGIconProps {
  bordered?: boolean;
  variant?: 'success' | 'warning' | 'info' | 'muted';
}

const VerifiedIcon = ({
  bordered = false,
  variant = 'success',
  ...svgIconProps
}: VerifiedIconProps) => {
  const Icon = bordered ? BorderedIcon : SVGIcon;
  return (
    <Icon
      className={classNames({
        [styles.success]: variant === 'success',
        [styles.warning]: variant === 'warning',
        [styles.info]: variant === 'info',
        [styles.muted]: variant === 'muted',
      })}
      {...svgIconProps}
    >
      {verifiedIcon}
    </Icon>
  );
};

export default VerifiedIcon;
